import actionTypes from "../actions/actionTypes";

const _initState = {
  isLoading: false,
  file: null,
};

const manual = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_MANUAL_REQUEST:
      return { ...state, isLoading: true, file: null };

    case actionTypes.GET_MANUAL_SUCCESS: {
      return { ...state, isLoading: false, file: action.res };
    }
    case actionTypes.GET_MANUAL_FAILURE:
      return _initState;

    default:
      return state;
  }
};

export default manual;
